import { createContext, useContext } from 'react';

export interface FeedbackContextValue {
  openFeedback: () => void;
}

/**
 * Lets JumpPalette trigger the "Send feedback to aiai-loop" modal, which lives in Layout
 * (it needs the current route). Defaults to a no-op so JumpPalette can still
 * render standalone (e.g. in tests) without a provider.
 */
// eslint-disable-next-line react-refresh/only-export-components
export const FeedbackContext = createContext<FeedbackContextValue>({
  openFeedback: () => {},
});

export function useFeedback(): FeedbackContextValue {
  return useContext(FeedbackContext);
}
